app.service('productSeeRecommended',function(productCardConfig, callback, console, logData) {
	var $self, config;

	function load() {
		var url = logData.showRecommendationsFromAWSonProductCard() ? '/user-personalized-see-also-carousel.ltr' : '/see-also-carousel.ltr';
		var data={
			productId:config.id
		};
		if (logData.showRecommendationsFromAWSonProductCard()){
			data.userId = logData.customerId();
		}

		$.ajax({
			url:url,
			data:data,
			success: function(html) {
				loadSuccess(html, data);
			},
			error:function(){
				loadError(data);
			}
		});
	}

	function loadSuccess(html, data) {
		$self.html(html);
		console.log('Załadowano karuzelę "zobacz także".');
		setElements();
		$self.productSlider();
	}
	function loadError(data) {
		console.log('Błąd ładowania karuzeli "zobacz także".');
	}
	function setEvents() {
	}
	function setElements() {
		$self = $('#see-recommended');
	}
	function init() {
		config=productCardConfig.getData();
		setElements();
		setEvents();
		if(config.recommendationsEnabled) {
			load();
		}
	}
	return {
		init:init
	};
});
